var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrescriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.7,
    height: 24.862,
    viewBox: "0 0 28.7 24.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prescriptionIcon",
    transform: "translate(-1051.979 -172.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M1056.43,190.17h0a2.262,2.262,0,0,1,0-3.188l3.748-3.748a2.254,2.254,0,0,1,3.188,3.187l-3.749,3.749A2.263,2.263,0,0,1,1056.43,190.17Z",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x2: 3.188,
    y2: 3.188,
    transform: "translate(1058.315 185.097)",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M1067.317,187.835v-5.994a2.447,2.447,0,0,0-.584-1.593l-2.671-3.233",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1055.734,176.993l-2.671,3.233a2.447,2.447,0,0,0-.584,1.593v12.032a2.509,2.509,0,0,0,2.514,2.514h9.787a2.4,2.4,0,0,0,1.257-.336",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 13.267,
    height: 4.467,
    rx: 1.549,
    transform: "translate(1053.286 172.526)",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    y2: 1.616,
    transform: "translate(1057.62 173.896)",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    y2: 1.616,
    transform: "translate(1059.91 173.896)",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    y2: 1.616,
    transform: "translate(1062.199 173.896)",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1077.62,191.763c-.988.651-2.626,1.258-5.589,1.258-3.1,0-5.59-1.055-5.59-2.357,0-.584.494-1.1,1.325-1.527",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M1077.62,194.031c0,1.3-2.514,2.357-5.589,2.357-3.1,0-5.59-1.055-5.59-2.357",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y1: 2.267,
    transform: "translate(1077.62 191.763)",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    y1: 3.39,
    transform: "translate(1066.441 190.641)",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M1074.589,182.65q.551,0,1.091.045t1.048.134c.339.06.661.132.967.218a7.346,7.346,0,0,1,.847.293,4.847,4.847,0,0,1,.7.358,2.806,2.806,0,0,1,.516.407,1.6,1.6,0,0,1,.318.442,1.034,1.034,0,0,1,0,.92,1.6,1.6,0,0,1-.318.442,2.8,2.8,0,0,1-.516.407,4.846,4.846,0,0,1-.7.358,7.343,7.343,0,0,1-.847.293c-.306.086-.628.158-.967.218s-.688.1-1.048.134-.724.045-1.091.045-.73-.015-1.09-.045-.71-.075-1.049-.134-.661-.132-.966-.218a7.279,7.279,0,0,1-.847-.293,4.844,4.844,0,0,1-.695-.358,2.846,2.846,0,0,1-.517-.407,1.64,1.64,0,0,1-.318-.442,1.042,1.042,0,0,1,0-.92,1.641,1.641,0,0,1,.318-.442,2.848,2.848,0,0,1,.517-.407,4.846,4.846,0,0,1,.695-.358,7.282,7.282,0,0,1,.847-.293c.3-.086.627-.158.966-.218s.689-.1,1.049-.134S1074.222,182.65,1074.589,182.65Z",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M1074.589,186.017a6.924,6.924,0,0,1-4.175-1.01,7.1,7.1,0,0,1,4.175-1.01,6.921,6.921,0,0,1,4.176,1.01A7.1,7.1,0,0,1,1074.589,186.017Z",
    fill: "#786987"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M1080.179,188.4c0,1.3-2.514,2.357-5.589,2.357-3.1,0-5.59-1.055-5.59-2.357",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    y1: 3.39,
    transform: "translate(1080.179 185.007)",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y1: 3.39,
    transform: "translate(1069 185.007)",
    fill: "none",
    stroke: "#786987",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionIcon);
export default __webpack_public_path__ + "static/media/prescriptionIcon.fde2af81ed81f5b75b10ff7ee141603b.svg";
export { ForwardRef as ReactComponent };